// Product Details Page

if($('.configure-option.required').length > 0 && $('#bundle').length <= 0) {
 $('[data-required=true]').each(function() {
    $(this).attr('required', 'required');
 });
}